import React, { useEffect, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Instagram, Facebook, Youtube, ExternalLink } from 'lucide-react';
import { siteConfig } from '../mock';

const SocialMarquee = () => {
  const marqueeRef = useRef(null);
  
  const socialPlatforms = [
    { name: 'Facebook', icon: Facebook, url: siteConfig.socialLinks.facebook, handle: 'GR la Saline Réunion' },
    { name: 'Instagram', icon: Instagram, url: siteConfig.socialLinks.instagram, handle: '@gr_lasaline' },
    { name: 'YouTube', icon: Youtube, url: siteConfig.socialLinks.youtube, handle: 'GR La Saline' },
  ];

  const marqueeContent = [...socialPlatforms, ...socialPlatforms, ...socialPlatforms];

  return (
    <section className="relative py-20 bg-gradient-to-r from-fuchsia-950/20 via-black to-pink-950/20 overflow-hidden">
      {/* Marquee Container */}
      <div className="relative">
        <motion.div
          ref={marqueeRef}
          animate={{
            x: [0, -1920]
          }}
          transition={{
            x: {
              duration: 40,
              repeat: Infinity,
              ease: 'linear'
            }
          }}
          className="flex gap-16 whitespace-nowrap"
        >
          {marqueeContent.map((platform, index) => (
            <a
              key={index}
              href={platform.url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-4 group"
            >
              <div className="w-12 h-12 rounded-full bg-white/5 border border-white/10 flex items-center justify-center group-hover:border-fuchsia-500/50 transition-colors duration-300">
                <platform.icon className="text-white/60 group-hover:text-fuchsia-400 transition-colors duration-300" size={20} />
              </div>
              <div className="flex flex-col">
                <span className="text-white/40 text-xs uppercase tracking-wider">{platform.name}</span>
                <span className="text-white text-xl font-semibold">{platform.handle}</span>
              </div>
              <ExternalLink className="text-white/20 group-hover:text-fuchsia-400 transition-colors duration-300" size={16} />
              <span className="text-6xl text-white/10 font-bold mx-8">•</span>
            </a>
          ))}
        </motion.div>
      </div>

      {/* Gradient Overlays */}
      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-black to-transparent z-10" />
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-black to-transparent z-10" />
    </section>
  );
};

export default SocialMarquee;
